<!-- 编辑供应商 -->
<template>
  <div>
      <setDialog
        dialogTitle="编辑供应商"
        :centerDialogVisible="editVisible"
        @resetPopupData="setUpdateVisible"
        @submitPopupData="setSubmitPopupData"
        :popupWidth="'420px'"
      >
        <el-form :model="setForm" :rules="rules" ref="setForm">
          <el-form-item
            label="供应商名称:"
            :label-width="formLabelWidth"
            prop="supplierName"
          >
            <el-input
              disabled
              v-model="setForm.supplier"
              autocomplete="off"
              placeholder="请输入供应商名称"></el-input>
          </el-form-item>
          <el-form-item
            label="供应商分级:"
            :label-width="formLabelWidth"
            prop="level"
          >
            <el-select
              v-model="setForm.supplierLevel"
              placeholder="请选择分级"
              style="width:250px"
            >
              <el-option
                v-for="item in levelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          
          </el-form-item>
          <el-form-item
            label="常采目录"
            :label-width="formLabelWidth"
            prop="catalog"
          >
            <el-input
              v-model="setForm.collectCatalog"
              autocomplete="off"
              placeholder="请输入常采目录"
              
            ></el-input>
          </el-form-item>

             <el-form-item label="所在地区:" :label-width="formLabelWidth" prop="area">
            <el-select
              v-model="setForm.area"
              placeholder="请选择地区"
              style="width:250px"
            >
              <el-option
                v-for="item in areaList"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaName"
              ></el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="合作状态:" :label-width="formLabelWidth" prop="status">
               <el-radio-group v-model="setForm.cooperationStatus">
                <el-radio :label="1">启动</el-radio>
                <el-radio :label="0">停用</el-radio>
               </el-radio-group>
          </el-form-item>
          
          <el-form-item label="添加时间:" :label-width="formLabelWidth" >
               <span>{{setForm.createTime}}</span>
          </el-form-item>
        </el-form>
      </setDialog>
  </div>
</template>

<script>
import setDialog from "@/components/common/epecDialog";
import api from '../../../api/user'
import util from "../../../utils/utils";
export default {
   props: {
    supplierInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    editVisible:{
        type:Boolean,
        default:false
    }
    },
  data () {
     
    return {
        levelList:[
            {label:'战略',value:1},
            {label:'重要',value:2},
            {label:'一般',value:3}
        ],
        setVisible:true,
        rules:{
             skuStock: [
                { required: true, message: '请输入库存', trigger: 'blur' },
          
          ],
           minOrderQuantity: [
              { required: true, message: '请输入起订量', trigger: 'blur' },
          ],
           deliverTime: [
             { required: true, message: '请输入发货周期', trigger: 'blur' },
          ],
            unitValue: [
            {  required: true, message: '请选择计量单位', trigger: 'change' }
          ],
       
        },
        // setForm:this.supplierInfo,
        unitList:[],
        formLabelWidth:'90px',
        areaList:[]
    };
  },

  components: {setDialog},

  computed:{
    setForm(){
        return this.supplierInfo;
    }
  },

 created() {
 },
 mounted(){
    console.log(111);
    // this.setForm = JSON.parse(JSON.stringify(this.supplierInfo));
    this.getProvinceList();
 },
 methods:{
        //获取省
    async getProvinceList(){
      let res = await api.queryByParentId();
      if(parseInt(res.code) === 200){
          let data = res.data;
          this.areaList = data;
      }
    },
        // 批量弹框的单位选择
    handleArea(val) {
        console.log(val);
      let obj = util.getSelectLabel(
        this.areaList,
        val,
        "areaId"
      );
      console.log(obj);
      this.setForm.area = obj.areaId;
    },
     setUpdateVisible(){
         this.$emit('setUpdateVisible',2)
     },
     setSubmitPopupData(){
        console.log(this.setForm);
        this.$refs['setForm'].validate((valid) => {
          if (valid) {
             this.$emit('setSubmitPopupData',this.setForm);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
     }
 }
}

</script>
<style lang='scss' scoped>
</style>